import React from "react";
import iconAccount from "../assets/img/icon_account.svg";

const Account = () => {
  return (
    <section className="section account-section">
      <h2 className="section-title">
        <i>
          <img src={iconAccount} alt="" />
        </i>
        アカウント管理
      </h2>

      <div className="account-group">
        <div className="group-wrapper">
          <p className="explain">
            メールアドレスとパスワードを変更されたい場合は、<br />
            下記より変更をお願い致します。
          </p>

          <div className="btn-green">
            <a href="/email">メールアドレス変更</a>
          </div>

          <div className="btn-green-2">
            <a href="/change-password">パスワード変更</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Account;